import { get, remove as httpRemove } from '../../Services/http';
export const MONITOR_RECEIVE = 'MONITOR_RECEIVE';
export const MONITOR_ERROR = 'MONITOR_ERROR';

const rootRoute = '/api/mypagemonitor';


export const query = () => (dispatch) => {
    return get(rootRoute)
        .then(response => response.json())
        .then(result => {
            dispatch(receive(result));
        });
}

export const remove = (monitorId) => (dispatch) => 
    httpRemove(rootRoute, monitorId)
        .then(() => dispatch(query()));

const receive = (list) => ({
    type: MONITOR_RECEIVE,
    payload: {
        list
    },
})